import React from 'react';
import { ScorecardDataContent, SCORE_COLORS, SCORE_LABELS } from './types';

interface ScorecardSummaryProps {
  data: unknown;
  config: Record<string, unknown>;
}

const ScorecardSummary: React.FC<ScorecardSummaryProps> = ({ data }) => {
  const content = data as ScorecardDataContent | undefined;
  const score = content?.score;

  if (!score) {
    return <span className="text-neutral-300" title="Not rated yet">—</span>;
  }

  const colors = SCORE_COLORS[score];
  return (
    <span
      title={`${score} — ${SCORE_LABELS[score]}`}
      className={`inline-block min-w-[32px] text-center px-2 py-0.5 text-xs font-bold rounded-full ${colors.bg} ${colors.text}`}
    >
      {score}
    </span>
  );
};

export default ScorecardSummary;
